export default __webpack_public_path__ + "static/media/addComment.6a03ffc1.svg";